import { variantJS } from '@variantjs/vue';

import TButton from './components/TButton';
import TModal from './components/TModal';
import TDropdown from './components/TDropdown';
import TSelect from './components/TSelect';
import TRichSelect from './components/TRichSelect';

// It was based on these docs https://www.vue-tailwind.com/docs/installation#3-configure-vue-to-use-vue-tailwind

const settings = {
    ...TButton,
    ...TModal,
    ...TDropdown,
    ...TSelect,
    ...TRichSelect,
};

export { variantJS, settings };
